import { Link } from "react-router-dom"
import { RoundedRectangle } from "../views/atoms/roundedrectangle/RoundedRectangle"
import { ButtonLabel, Spacer } from "../views/atoms/Atoms"
import { SinglePathSVG } from "../views/SVG"
// @ts-ignore
import styles from "css/colors.scss"
import React, { FC } from "react"
import { CircleImage } from "../views/atoms/images/CircleImage"
import { useSelector } from "react-redux"
import { getEmployeeId } from "../../reducers/userInfo"

type TalkToCarrotButtonProps = {
  to: string
  iconName?: string
  label: string
  useModal?: boolean
  enabled?: boolean
  chatType?: string
}

type ButtonContentType = {
  iconName?: string
  label: string
  enabled?: boolean
}

const TalkToCarrotButton: FC<TalkToCarrotButtonProps> = ({
  to,
  iconName,
  label,
  useModal = false,
  enabled = true,
  chatType = null
}: TalkToCarrotButtonProps) => {
  const employeeId = useSelector(getEmployeeId)

  const onClick = () => {
    // Adapted from the "Pop-up text" JavaScript snippet Calendly generates for us
    // https://help.calendly.com/hc/en-us/articles/223147027-Embed-options-overview#1
    window.Calendly.initPopupWidget({
      url: to,
      utm: {
        utmCampaign: employeeId,
        utmSource: chatType
      }
    })
    return false
  }
  const cursorType = enabled ? "pointer" : "not-allowed"
  const buttonOpacity = enabled ? "" : "o-30"
  const onClickHandler = enabled ? onClick : null

  return useModal ? (
    <div className={buttonOpacity}>
      <a onClick={onClickHandler} className={`no-underline ${cursorType}`}>
        <ButtonContents label={label} iconName={iconName} enabled={enabled} />
      </a>
    </div>
  ) : (
    <div className={buttonOpacity}>
      <Link to={to} className={`no-underline ${cursorType} `}>
        <ButtonContents label={label} iconName={iconName} enabled={enabled} />
      </Link>
    </div>
  )
}

const ButtonContents: FC<ButtonContentType> = ({ iconName, label, enabled = true }: ButtonContentType) => {
  return (
    <RoundedRectangle
      backgroundColor="white"
      borderColor={`mineral-grey ${enabled ? "hover-b--carrot-orange" : ""}`}
      padding="pt35 pl35 pr3 pb3"
    >
      {iconName && <CircleImage iconName={iconName.valueOf()} backgroundColor="icon-grey" />}
      <Spacer height={1} />
      <div className="w-100 flex justify-between">
        <ButtonLabel>{label}</ButtonLabel>
        <Spacer width={0.5} />
        <div style={{ minWidth: "10px" }}>
          <SinglePathSVG icon="rightArrow" fill={styles.carrotOrange} additionalClasses="mt1" />
        </div>
      </div>
    </RoundedRectangle>
  )
}

export { TalkToCarrotButton, ButtonContents }
